export const defaultErrorMessage = 'An undetermined error has occurred.';

export const getCustomError = (message: any) => {
  if (!!message) {
    return new Error(message);
  }

  return getDefaultError();
};

export const getDefaultError = (): Error => new Error(defaultErrorMessage);
